import React, {useMemo} from "react";
import {AsideMenuList} from "./AsideMenuList";
import {useHtmlClassService} from "../../..";
import {toAbsoluteUrl} from "../../../../_helpers";
import {Link} from "react-router-dom";
import {shallowEqual, useSelector} from "react-redux";
import {ROLES} from "../../../../../app/partials/Enums";

export function AsideMenu({disableScroll}) {
  const uiService = useHtmlClassService();
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      asideMenuAttr: uiService.getAttributes("aside_menu"),
      ulClasses: uiService.getClasses("aside_menu_nav", true),
      asideClassesFromConfig: uiService.getClasses("aside_menu", true)
    };
  }, [uiService]);

  return (
    <>
      {/* begin::Menu Container */}
      <div
        id="kt_aside_menu"
        data-menu-vertical="1"
        className={`aside-menu my-4 ${layoutProps.asideClassesFromConfig}`}
        {...layoutProps.asideMenuAttr}
        style={{
          backgroundImage: `url(${toAbsoluteUrl("/media/bg/left-bg.jpg")})`
        }}
      >
        {
          user.role === ROLES.COMPANY_ADMIN
          &&
          (
            <div className="text-center">
              <Link to="/projects/new" className="btn btn-primary btn-lg mt-5 mb-2">
                <i className="fa fa-plus"></i> Create Project
              </Link>
            </div>
          )
        }
        <AsideMenuList layoutProps={layoutProps} />
      </div>
      {/* end::Menu Container */}
    </>
  );
}
